import type { FC, ReactElement } from 'react'

import Dropdown from 'react-dropdown'

import { useAppContext } from '@/app/index.context'

import './Tabs.styles.scss'

const Tabs: FC<{
  className?: string
  tabs: { value: number | string; label: string | ReactElement }[]
  selectedValue?: number | string
  isTabChangeable?: boolean
  onClick?: (val: number | string) => void
}> = ({ className, tabs = [], selectedValue, isTabChangeable = true, onClick = () => {} }) => {
  const { whiteLabel } = useAppContext()
  const dropdownValues = tabs.map(option => ({
    value: String(option.value),
    label: option.label,
  }))

  return (
    <div className="tabs">
      <div className={`tabs__fullscreen ${className || ''}`}>
        {tabs.map((tab, idx) => {
          const { value, label } = tab
          return (
            <button
              type="button"
              disabled={!isTabChangeable && value !== selectedValue}
              key={idx}
              className={`tab-button ${value === selectedValue ? 'selected' : ''} ${whiteLabel}`}
              onClick={() => onClick(value)}
            >
              {label}
            </button>
          )
        })}
      </div>

      <Dropdown
        // Fix when refactoring
        // @ts-ignore
        tabIndex={0}
        className="tabs__handheld"
        value={dropdownValues.find(option => option.value === String(selectedValue))}
        onChange={({ value }) => onClick(isNaN(Number(value)) ? value : Number(value))}
        options={dropdownValues}
      />
    </div>
  )
}

export default Tabs
